import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})

export class CreditCardTypeService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    GetAllCreditCardsByMarket(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/CreditCard/GetCreditCardTypesByMarket`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    saveCreditCardTypesByMarket(data: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/CreditCard/SaveCreditCardTypesByMarket`,
            data,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getCreditCardFeeSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/CreditCard/GetCreditCardFeeSettings`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    saveCreditCardFeeSettings(data: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/CreditCard/SaveCreditCardFeeSettings`,
            data,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}